import { FormErrorMessage, FormItem } from "@/components/ui/form/_base/form";
import { DatePickerRange } from "@/components/ui/input/date-picker-range";

import { useVoucherCheckInPeriodAvailable } from "./hooks";

export const QuestionVoucherCheckInPeriodAvailable = () => {
	const { shouldShowCheckInPeriodAvailableSection, onSetCinStartOrCinEnd, cinStart, cinEnd } =
		useVoucherCheckInPeriodAvailable();

	return (
		<>
			{shouldShowCheckInPeriodAvailableSection && (
				<FormItem>
					<div className="flex flex-col gap-y-1">
						<label className="text-sm">チェックイン可能な期間</label>
						<DatePickerRange
							selected={{
								from: cinStart?.value ?? undefined,
								to: cinEnd?.value ?? undefined,
							}}
							onSelect={onSetCinStartOrCinEnd}
						/>
					</div>

					<FormErrorMessage>{cinStart?.error || cinEnd?.error}</FormErrorMessage>
				</FormItem>
			)}
		</>
	);
};

QuestionVoucherCheckInPeriodAvailable.displayName = "QuestionVoucherCheckInPeriodAvailable";
